import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { axiosInstance, instanceAuth } from "api/apiConfig"
import { Alert } from "reactstrap"
import {
  AUTH_USER_LOGIN_CONSTANT,
  AUTH_USER_REGISTER_CONSTANT,
  AUTH_USER_SENDCODE,
  AUTH_USER_VERIFY,
  REGISTER_AUTHENTICATOR,
  SHUK_AUTH_PORTAL_TOKEN,
} from "redux/enums"
import { parseJwt } from "utilities/parse-jwt"

const INITIAL_STATE = {
  firstname: "Arham",
  middlename: "Abeer",
  lastname: "Ahmed",
  email: "arham.abeer@braincrop.net",
  dob: "04-09-1999",
  contact: "090078601",
  role: "admin",
  loading: false,
  error: false,
  apiStatus: false,
  response: {},
  respFrom: "",
  userRole: null, // Add this line
}

// Add this new thunk
export const fetchUserRoleFromToken = createAsyncThunk(
  "user/fetchUserRoleFromToken",
  async () => {
    try {
      const token = localStorage.getItem(SHUK_AUTH_PORTAL_TOKEN)
      if (!token) {
        return null
      }
      const parsedDetails = await parseJwt(token)
      const userRole = parsedDetails?.[
        "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
      ] || parsedDetails?.role || parsedDetails?.Role
      return userRole
    } catch (error) {
      console.error("Error fetching user role from token:", error)
      return null
    }
  }
)

export const RegisterUser = createAsyncThunk(
  AUTH_USER_REGISTER_CONSTANT,
  async data => {
    try {
      const response = await axiosInstance.post("Auth/Register", data.data)
      console.log("response: ", response)

      if (response.status === 200) {
        const _res = {
          response: response.data,
        }
        return _res
      }
      throw response?.data
    } catch (error) {
      console.log("response: ", error?.message)

      throw error?.response?.data ? error?.response?.data : error?.message
    }
  },
)

export const LoginUser = createAsyncThunk(
  AUTH_USER_LOGIN_CONSTANT,
  async data => {
    try {
      const response = await axiosInstance.post("Auth/Login", data)
      if (response.status === 200) {
        console.log("response", response)
        const token = response?.data?.data?.token
        localStorage.setItem(SHUK_AUTH_PORTAL_TOKEN, token)
        
        // Parse token to get user role
        let userRole = null
        try {
          const parsedDetails = await parseJwt(token)
          userRole = parsedDetails?.[
            "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
          ] || parsedDetails?.role || parsedDetails?.Role
        } catch (e) {
          console.log("Error parsing token for role:", e)
        }
        
        const _res = {
          response: response?.data,
          userRole: userRole,
        }
        return _res
      }
      return response.data
    } catch (error) {
      console.log("error login", error?.response?.data)
      return error?.response
    }
  },
)

export const sendAuthenticatorCode = createAsyncThunk(
  AUTH_USER_SENDCODE,
  async email => {
    try {
      const response = await axiosInstance.post(
        `Auth/SendEmailTwoFactorOTP/${email}`,
      )
      console.log("response from send code api: ", response)
      if (response.status === 200) {
        const _res = {
          response: response?.data,
          status: response?.status,
        }
        return _res
      }
      throw Error("Error sending authentication code.")
    } catch (error) {
      console.log("error login", error?.response?.data)
      throw error?.response?.data ? error?.response?.data : error
    }
  },
)

export const verifyAuthenticatorCode = createAsyncThunk(
  AUTH_USER_VERIFY,
  async data => {
    try {
      const response = await axiosInstance.post("Auth/LoginWith2FA", data)
      if (response.status === 200) {
        console.log("my token", response)
        const token = response.data?.token || response.data?.data?.token
        localStorage.setItem(SHUK_AUTH_PORTAL_TOKEN, token)
        
        // Parse token to get user role
        let userRole = null
        try {
          const parsedDetails = await parseJwt(token)
          userRole = parsedDetails?.[
            "http://schemas.microsoft.com/ws/2008/06/identity/claims/role"
          ] || parsedDetails?.role || parsedDetails?.Role
        } catch (e) {
          console.log("Error parsing token for role:", e)
        }
        
        const _res = {
          status: response?.status,
          response: response?.data,
          userRole: userRole,
        }
        return _res
      }
      throw Error("Wrong Code")
    } catch (error) {
      throw error?.response?.data ? error?.response?.data : error
    }
  },
)

export const registerAuthenticator = createAsyncThunk(
  REGISTER_AUTHENTICATOR,
  async data => {
    try {
      const response = await instanceAuth.post("Auth/Manage2FA", data)
      if (response.status === 200) {
        console.log("registerAuthenticator", response)
        const _res = {
          status: response?.status,
          response: response?.data,
        }
        return _res
      }
      throw Error("Wrong Code")
    } catch (error) {
      throw error?.response?.data ? error?.response?.data : error
    }
  },
)

export const UserSlice = createSlice({
  initialState: INITIAL_STATE,
  name: "userSlice",
  reducers: {
    setApiResponseStutusToDefault: (state, action) => {
      return { ...state, apiStatus: false, error: false, response: {} }
    },
    setLogoutUser: (state, action) => {
      console.log("logout", action.payload)
      localStorage.removeItem(SHUK_AUTH_PORTAL_TOKEN)
      action.payload("/login")
      return { ...state, apiStatus: false, error: false, response: {}, userRole: null }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(RegisterUser.pending, (state, action) => {
        state.loading = true
      })
      .addCase(RegisterUser.fulfilled, (state, action) => {
        console.log("register fulfilled: ", action.payload)
        state.response = action.payload.response.message
        state.respFrom = "Register"
        state.apiStatus = true
        state.loading = false
      })
      .addCase(RegisterUser.rejected, (state, action) => {
        console.log("register rejected: ", action)
        state.response = action.error.message
        state.respFrom = "Register"
        state.apiStatus = true
        state.error = true
        state.loading = false
      })
    builder
      .addCase(LoginUser.pending, (state, action) => ({
        ...state,
        ...action.payload,
        loading: true,
      }))
      .addCase(LoginUser.fulfilled, (state, action) => {
        console.log("login fulfilled: ", action.payload)
        state.response = action.payload?.response?.data?.message || action.payload?.data?.message || action.payload?.message || ""
        state.respFrom = "Login"
        if(action.payload?.status === 500){
          state.error = true
        } else{
          state.error = false
          state.userRole = action.payload?.userRole || null
        }
        state.apiStatus = true
        state.loading = false
      })
      .addCase(LoginUser.rejected, (state, action) => {
        console.log("login rejected: ", action)
        state.response = action.error.message
        state.respFrom = "Login"
        state.apiStatus = true
        state.error = true
        state.loading = false
      })
    builder
      .addCase(sendAuthenticatorCode.pending, (state, action) => {
        state.loading = true
      })
      .addCase(sendAuthenticatorCode.fulfilled, (state, action) => {
        state.response = action.payload.response?.message
          ? action.payload.response?.message
          : "Code Send"
        state.apiStatus = true
        state.loading = false
      })
      .addCase(sendAuthenticatorCode.rejected, (state, action) => {
        state.response = action.error.message
        state.error = true
        state.loading = false
      })
    builder
      .addCase(verifyAuthenticatorCode.pending, (state, action) => {
        state.loading = true
      })
      .addCase(verifyAuthenticatorCode.fulfilled, (state, action) => {
        console.log("code verified: ", action.payload)
        state.response = action.payload.response.message
        state.apiStatus = true
        state.loading = false
        state.userRole = action.payload?.userRole || null
      })
      .addCase(verifyAuthenticatorCode.rejected, (state, action) => {
        console.log("error verifying code: ", action)
        state.response = action.error.message
        state.error = true
        state.loading = false
      })
    builder
      .addCase(registerAuthenticator.pending, (state, action) => {
        state.loading = true
      })
      .addCase(registerAuthenticator.fulfilled, (state, action) => {
        console.log("register authenticator: ", action.payload)
        state.response = action.payload.response.message
        state.apiStatus = true
        state.loading = false
      })
      .addCase(registerAuthenticator.rejected, (state, action) => {
        console.log("error register authenticator: ", action)
        state.response = action.error.message
        state.error = true
        state.loading = false
      })
    // Add reducer for fetchUserRoleFromToken
    builder
      .addCase(fetchUserRoleFromToken.fulfilled, (state, action) => {
        state.userRole = action.payload
      })
  },
})

export const { setApiResponseStutusToDefault, setLogoutUser } =
  UserSlice.actions
export const userData = state => state.user
export const selectUserRole = state => state.user.userRole
export default UserSlice.reducer